<template>
  <div style="width:100%;">
    <v-card width="400" style="margin-left:auto;margin-right:auto;" outlined>
      <v-card-title>
        <h2>{{ $t("login.login") }}</h2>
      </v-card-title>
      <v-card-text>
        <v-form @submit="login">
          <v-text-field type="text" :label="$t('login.email')" v-model="email"></v-text-field>
          <v-text-field type="password" :label="$t('login.password')" v-model="password"></v-text-field>
          <v-btn type="submit" depressed>{{ $t("login.login") }}</v-btn>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="openRegister">{{ $t("login.register_now") }}</v-btn>
        <v-btn text @click="forgotPassword">{{ $t("login.forgot_password") }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog width="300" persistent v-model="d_two_factor_authentication">
      <v-card>
        <v-card-title>{{ $t("login.two_factor_authentication") }}</v-card-title>
        <v-card-text>
          <v-text-field maxlength="6" placeholder="- - - - - -" ref="input_otp_code" v-model="otp_code" @keyup="submitOnOTPKeyDown" :label="$t('settings.code')"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="login" text>{{ $t("login.verify") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { auth, storage } from "./../schmucklicloud";
import { Notifications } from "./../notification";

export default {
  async mounted() {},
  data() {
    return {
      email: "",
      password: "",

      d_two_factor_authentication: false,
      otp_code: undefined
    };
  },
  methods: {
    openRegister() {
      this.$router.replace("/register");
    },
    forgotPassword() {
      this.$router.replace("/forgot");
    },
    submitOnOTPKeyDown(e) {
      if (this.otp_code.length === 6) {
        this.login(e);
      }
    },
    async login(e) {
      e.preventDefault();

      var response = await auth.authorizeEmailPassword(
        this.email,
        this.password,
        this.otp_code
      );
      if (response.status_code === 200) {
        localStorage.setItem("session_token", response.data.session_token);
        Notifications.show("Successfully signed in.");

        // Set the auth token to the objects
        storage.setAuthToken(response.data.session_token);

        this.$router.replace("/");
      } else if(response.status_code === 300) {
        this.d_two_factor_authentication = true;
        setTimeout(function(){
          this.$refs.input_otp_code.focus();
        }.bind(this), 500);
      } else {
        if (response.status_code === 400) {
          this.otp_code = "";
        }
        Notifications.show(response.message);
      }
    }
  }
};
</script>

<style>
</style>